import React from 'react';
import { Field, FormSection } from 'redux-form/immutable';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import Entrepreneur from '../sections/entrepreneur';
import RegionSelector from '../sections/region-selector';
import { Api } from '../api';
import {
  SimpleInput,
  Textarea,
  Checkbox,
  MaskedInput,
  RadioButton,
  FileInput,
  makeSelectInput,
  RadioPublicButton,
} from '../field-components';
import { required, validateYear0, validateEmail, validateAddress } from '../validators';
import messages from '../messages';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import makeSelectData from '../selectors';
import { toast } from 'react-toast';
import { errorTypes } from '../utils';
import DisabilitySelector from '../sections/disability-selector';
import Publicity from '../sections/publicity';
import AppealCollectivity from '../sections/appeal-collectivity';
import FullName from '../sections/fullname';

class MainForm extends React.Component {
  constructor(props) {
    super(props);
    this.StatusSelectInput = makeSelectInput(Api.fetchStatus);
  }

  onSubmit = () => {
    const { formConfig, appState } = this.props;
    const { form, formName } = formConfig;

    if (appState[form].syncErrors) {
      const requiredErrors = appState[form].syncErrors[formName];
      Object.keys(requiredErrors)
        // .filter((error) => requiredErrors[error] === 'required')
        .forEach((err) => {
          console.log(err, requiredErrors[err]);
          if (requiredErrors[err] === 'required')
            toast(
              <FormattedMessage
                {...messages.needed_field}
                values={{
                  attribute: (
                    <strong>
                      <FormattedMessage {...messages[errorTypes[err] || err]} />
                    </strong>
                  ),
                }}
              />,
              { backgroundColor: '#f2dede', color: '#a94442' },
            );

          if (requiredErrors[err] instanceof Object && 'id' in requiredErrors[err]) {
            toast(<FormattedMessage {...requiredErrors[err]} />, {
              backgroundColor: '#f2dede',
              color: '#a94442',
            });
          }
        });
    }
  };

  render() {
    const {
      handleSubmit,
      isPersecution,
      initialValues,
      goBack,
      scrollTo,
      isNormalForm,
      isJuridicalChecked,
      action,
      change,
      appState,
      draftId,
      sendDraft,
      formConfig: { form, formName, formType },
    } = this.props;

    const tin = appState[form].values[formName].juridical_tin;
    const mahalla_id = appState[form].values[formName].mahalla_id;
    const uploadedFiles = appState[form].values[formName].user_file;
    const region_id = appState[form].values[formName].region_id;
    const is_collective = appState[form].values[formName].is_collective;

    console.log('appState', appState);

    return (
      <div className="send-appeal-form" ref={scrollTo}>
        <form className="card-block clearfix" onSubmit={handleSubmit}>
          <div className="col-md-6">
            <FullName formName={formName} />

            <FormSection>
              <RegionSelector
                formName={formName}
                formCodeName={form}
                initialValues={initialValues}
                change={change}
                action={action}
                mahallaId={mahalla_id}
                regionId={region_id}
              />
            </FormSection>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.address} />
              </label>
              <Field
                name={`${formName}[current_address]`}
                type="text"
                component={SimpleInput}
                validate={[required, validateAddress]}
                forceEdit={true}
                className="form-control"
                autoComplete="off"
              />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.gender} />
              </label>
              <Field
                labelStyle={{
                  marginRight: '20px',
                  marginLeft: '20px',
                  lineHeight: 'inherit',
                }}
                name={`${formName}[gender]`}
                validate={[required]}
                component={RadioButton}
                inputValue="m"
                label={<FormattedMessage {...messages.man} />}
              />
              <Field
                labelStyle={{
                  marginRight: '20px',
                  marginLeft: '20px',
                  lineHeight: 'inherit',
                }}
                name={`${formName}[gender]`}
                validate={[required]}
                component={RadioButton}
                inputValue="f"
                label={<FormattedMessage {...messages.woman} />}
              />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.birthdate} />
              </label>
              <Field
                name={`${formName}[birthday]`}
                type="text"
                component={MaskedInput}
                mask="XX.XX.1111"
                placeholder="dd.mm.yyyy"
                validate={[required, validateYear0]}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="item clearfix">
              <label className="form-label text-left col-md-3" style={{ lineHeight: 'inherit', marginTop: 15 }}>
                <FormattedMessage {...messages.email} />
              </label>
              <Field
                name={`${formName}[email]`}
                type="email"
                component={SimpleInput}
                validate={[validateEmail]}
                placeholder="example@mail.com"
                className="form-control"
              />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.status} />
              </label>
              <Field name={`${formName}[employment_id]`} validate={[required]} component={this.StatusSelectInput} />
            </div>
            <DisabilitySelector formName={formName} />
            <AppealCollectivity formName={formName} value={is_collective} />
            <Publicity formName={formName} />
            <FormSection>
              <Entrepreneur
                tin={tin}
                change={change}
                formName={formName}
                isNormalForm={isNormalForm}
                isJuridicalChecked={isJuridicalChecked}
              />
            </FormSection>
            <div className="item attachment-wrap clearfix">
              <div className="col-md-2" />
              <div className="col-md-10">
                <Field
                  name={`${formName}[user_file]`}
                  component={FileInput}
                  type="hidden"
                  sendDraft={sendDraft}
                  draftId={draftId}
                  defaultValue={uploadedFiles}
                />
              </div>
            </div>
            {isPersecution && (
              <React.Fragment>
                <div className="item clearfix">
                  <label
                    className="form-label text-left col-md-3"
                    style={{ lineHeight: 'inherit', marginBottom: '5px' }}
                  >
                    <FormattedMessage {...messages.request_no} />
                  </label>
                  <Field
                    name={`${formName}[request_no]`}
                    validate={[required]}
                    component={SimpleInput}
                    forceEdit
                    type="text"
                  />
                </div>
                <div className="item clearfix">
                  <label
                    className="form-label text-left col-md-3"
                    style={{ lineHeight: 'inherit', marginBottom: '5px' }}
                  >
                    <FormattedMessage {...messages.authority} />
                  </label>
                  <Field
                    name={`${formName}[authority]`}
                    validate={[required]}
                    component={SimpleInput}
                    forceEdit
                    type="text"
                  />
                </div>
              </React.Fragment>
            )}
          </div>

          <div className="form-bottom col-md-12">
            <div className="item aggrement-checkbox-wrap clearfix"></div>
            <div className="mgb-15 clearfix">
              <label className="">
                <FormattedMessage {...messages.applicationLabel} />
              </label>
              <Field name={`${formName}[description]`} component={Textarea} validate={[required]} />
              {/* <p className="note"><FormattedMessage {...messages.applicationHint} /></p> */}
            </div>

            <div className="row clearfix">
              {/* <Field name="captcha" component={CaptchaField} validate={[required]}/> */}

              <Field
                name={`${formName}[is_agree]`}
                className={window.isAuthByGcp ? 'col-md-6' : 'col-md-9'}
                component={Checkbox}
                onChange={(e) => {
                  let elem = document.getElementById(`${formName}-${formType}-offerModal-trigger`);
                  e.target.checked && elem && elem.click();
                }}
                id={`${formName}-${formType}-checkbox-aggrement`}
                validate={[required]}
                label={
                  <FormattedHTMLMessage
                    {...messages.agreementHint}
                    values={{
                      link: '#',
                      id: `${formName}-${formType}-offerModal-trigger`,
                      dataToggle: 'modal',
                      dataTarget: '#offerModal',
                    }}
                  />
                }
                labelStyle={{ marginBottom: 20 }}
                type="checkbox"
              />

              {/* <Field
                name={`${formName}[is_agree_electronically]`}
                className={window.isAuthByGcp ? 'col-md-6' : 'col-md-9'}
                component={Checkbox}
                id={`${formName}-${formType}-checkbox-is_agree_electronically`}
                label={<FormattedHTMLMessage {...messages.answerOnlyElectron} />}
                labelStyle={{ marginBottom: 20 }}
                type="checkbox"
              /> */}
              <div className="col-md-8">
                <Field
                  labelStyle={{
                    marginRight: '20px',
                  }}
                  name={`${formName}[is_agree_electronically]`}
                  id={`${formName}-${formType}-radio-is_agree_electronically`}
                  component={RadioPublicButton}
                  inputValue={true}
                  label={<FormattedHTMLMessage {...messages.answerOnlyElectron} />}
                />
                <Field
                  labelStyle={{
                    marginRight: '20px',
                  }}
                  name={`${formName}[is_agree_electronically]`}
                  id={`${formName}-${formType}-radio-is_agree_electronically_written`}
                  component={RadioPublicButton}
                  inputValue={false}
                  label={<FormattedHTMLMessage {...messages.answerElectronAndWritten} />}
                />
              </div>
            </div>
            <div className="col-md-12" style={{ marginTop: '10px' }}>
              {window.isAuthByGcp && (
                <div style={{ marginTop: '5px' }}>
                  <button
                    type="button"
                    className="btn submit_btn pull-right"
                    onClick={goBack}
                    style={{ background: 'rgb(43, 158, 217)' }}
                  >
                    <FormattedMessage {...messages.close} />
                  </button>
                </div>
              )}

              <div style={{ marginTop: '5px' }}>
                <button className="btn submit_btn pull-right" onClick={this.onSubmit}>
                  <FormattedMessage {...messages.sendButton} />
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  appState: makeSelectData(),
});

export default connect(mapStateToProps)(MainForm);



// WEBPACK FOOTER //
// ./src/application-form/forms/main.js